import { sanitizePath } from "../../../utils/sanitizePath";
import { s3 } from "./AwsS3";

type Props = {
  file: any;
  userId?: string;
  folderName: string;
  caseId?: string;
  inmateName?: string;
};

/**
 * Uploads an image to AWS S3.
 * @component uploadImageToS3
 * @author Sanjay
 *
 */

const ALLOWED_MIME_TYPES = ["application/pdf"];

const ALLOWED_EXTENSIONS = ["pdf"];

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB

const validateFile = (file: any): void => {
  if (!file) {
    throw new Error("No file provided");
  }
  if (!ALLOWED_MIME_TYPES.includes(file.type)) {
    throw new Error(`File type "${file.type}" is not allowed`);
  }
  if (file.size > MAX_FILE_SIZE) {
    throw new Error("File size exceeds the 50 MB limit");
  }
  const ext = file.name?.split(".")?.pop()?.toLowerCase();
  if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
    throw new Error(`File extension ".${ext}" is not allowed`);
  }
};

export const uploadDpsToS3 = async ({ file, caseId, inmateName }: any) => {
  validateFile(file);

  const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;
  // console.log({ caseId }, { inmateName });
  if (!bucketName) {
    throw new Error("AWS Bucket name is not defined in environment variables.");
  }

  // const params = {
  //   Bucket: bucketName, // Now we are sure it's a string
  //   Key: `document/${inmateName}-${caseId}/Report`,
  //   ContentType: file.type,
  //   Body: file,
  // };

  const timestamp = Date.now();
  const folderName = "Uploaded Documents";
  const sanitizedInmate = sanitizePath(inmateName);
  const sanitizedCaseId = sanitizePath(caseId);
  const extension = sanitizePath(file.name.split(".").pop()) || "bin";
  const fileName = `Report-${timestamp}.${extension}`;
  const params = {
    Bucket: bucketName,
    Key: `document/${sanitizedInmate}-${sanitizedCaseId}/Report-${timestamp}.pdf`,
    ContentType: file.type,
    Body: file,
  };

  try {
    const data = await s3.upload(params).promise();

    const destinationKey = `Cases/${sanitizedInmate}-${sanitizedCaseId}/${folderName}/${fileName}`;
    // const uploadDocumentParams = {
    //   Bucket: bucketName,
    //   CopySource: `document/${inmateName}-${caseId}/${fileName}`,
    //   Key: destinationKey,
    // };
    const uploadDocumentParams = {
      Bucket: bucketName,
      Key: destinationKey,
      ContentType: file.type,
      Body: file,
    };
    // Copy within S3
    // await s3.copyObject(uploadDocumentParams).promise();
    await s3.upload(uploadDocumentParams).promise();

    return data;
  } catch (err: any) {
    throw new Error(`Upload failed: ${err.message}`);
  }
};
